import { render, staticRenderFns } from "./SubDealerIndex.vue?vue&type=template&id=1c50f46b&scoped=true&lang=html&"
import script from "./SubDealerIndex.vue?vue&type=script&lang=js&"
export * from "./SubDealerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50f46b",
  null
  
)

export default component.exports